import { Box, Tooltip } from "@mui/material"
import * as constants from "lib/api"
import * as fmt from "lib/fmt"

interface buildInfoProps {
	appConfig: any
	title: string
}

export function BuildInfo({ appConfig, title }: buildInfoProps): React.JSX.Element {
	if (appConfig == null || appConfig[constants.BUILD] == null) {
		return <></>
	}

	const config = appConfig[constants.BUILD]

	if (!config) {
		return <></>
	}

	const version = config[constants.VERSION];
	const buildRun = config[constants.BUILD_RUN];

	if (!version && !buildRun) {
		return (
			<Tooltip
				title={config[constants.GIT_COMMIT] ?? "Git commit not available"}
				placement="left"
				arrow
			>
				<Box>
					<b>{title}: </b>
					Build info not available
					<br />
				</Box>
			</Tooltip>
		)
	}

	const versionDisplay = version
		? typeof version === "string"
			? version.Split("-")[0]
			: String(version)
		: "";

	const primaryLabel =
		versionDisplay && buildRun
			? fmt.Sprintf("%s-%s", versionDisplay, buildRun)
			: versionDisplay || String(buildRun ?? "");

	return (
		<Tooltip
			title={config[constants.GIT_COMMIT] ?? "Git commit not available"}
			placement="left"
			arrow
		>
			<Box>
				<b>{title}: </b>
				{primaryLabel}
				<br />
			</Box>
		</Tooltip>
	)
}
